import { useRef, useState } from "react";
import clsx from "clsx";

import { useTranslation } from "lib/i18n/use-translation";
import { useOuterClick } from "lib/utils/use-outer-click";

import HelpLeftImage from "assets/icons/help-left.svg?react";
import HelpRightImage from "assets/icons/help-right.svg?react";
import HelpIcon from "assets/icons/help.svg?react";
import css from "./help.module.scss";

export function Help() {
  const [isOpen, setIsOpen] = useState(false);
  const rootRef = useRef<HTMLDivElement>(null);

  const { t } = useTranslation();

  useOuterClick(rootRef, () => setIsOpen(false));

  return (
    <div ref={rootRef}>
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={clsx(css.trigger, isOpen && css.active)}
        title={t("Помощь")}
      >
        <HelpIcon width={24} height={24} />
      </button>
      {isOpen && (
        <div className={css.overlay} onClick={() => setIsOpen(false)}>
          <HelpLeftImage />
          <HelpRightImage />
        </div>
      )}
    </div>
  );
}
